const normalize = (value) =>
	String(value || "")
		.trim()
		.toLowerCase();

export const getMRProjectPath = (mr) =>
	mr?.project?.fullPath || mr?.projectPath || "";

export const getMRAuthorName = (mr) =>
	mr?.author?.name || mr?.author?.username || "";

export const getMRAuthorUsername = (mr) => mr?.author?.username || "";

export const escapeRegExp = (value) =>
	String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const getCompiledTitleRegex = (rule) => {
	if (!rule?.titleRegex) return null;

	try {
		return new RegExp(rule.titleRegex, "i");
	} catch {
		return null;
	}
};

export const getMRExclusionMatches = (mr, rule) => {
	if (!mr || !rule) return [];

	const matches = [];
	const titleRegex = getCompiledTitleRegex(rule);
	if (titleRegex?.test(mr.title || "")) {
		matches.push("title");
	}

	if (
		rule.projectPath &&
		normalize(getMRProjectPath(mr)) === normalize(rule.projectPath)
	) {
		matches.push("repo");
	}

	const authorName = normalize(getMRAuthorName(mr));
	const authorUsername = normalize(getMRAuthorUsername(mr));
	if (
		rule.authorName &&
		(authorName === normalize(rule.authorName) ||
			(rule.authorUsername &&
				authorUsername === normalize(rule.authorUsername)))
	) {
		matches.push("author");
	}

	return matches;
};

export const getMatchingExclusionRules = (mr, rules) =>
	(rules || [])
		.map((rule) => ({
			rule,
			matches: getMRExclusionMatches(mr, rule),
		}))
		.filter(({ matches }) => matches.length > 0);

export const isMRExcludedByRules = (mr, rules) =>
	getMatchingExclusionRules(mr, rules).length > 0;

export const summarizeExclusionRule = (rule) => {
	const parts = [];

	if (rule?.titleRegex) parts.push(`Title /${rule.titleRegex}/i`);
	if (rule?.projectPath) parts.push(`Repo ${rule.projectPath}`);
	if (rule?.authorName) parts.push(`Author ${rule.authorName}`);

	return parts.join(" OR ") || "Empty rule";
};
